import React from "react";

export default function EmailVerifyAlert() {
  return <div></div>;
}
